import { render } from "./CallBtn.vue?vue&type=template&id=a7200636&scoped=true"
import script from "./CallBtn.vue?vue&type=script&lang=js"
export * from "./CallBtn.vue?vue&type=script&lang=js"

import "./CallBtn.vue?vue&type=style&index=0&id=a7200636&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Тестовое TrueConf\\true_conf\\elevator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7200636"]])

export default __exports__